<app-navbar class="app-navbar" (leftNavToggle)="toggleSidebar()" (sidebarConfig)="changeSidebarConfig($event)"></app-navbar>
<mat-drawer-container class="app-container" autosize>
  <mat-drawer class="app-sidenav" mode="side" opened>
    <app-sidebar [configs]="leftSidenavConfigs"></app-sidebar>
  </mat-drawer>

  <div class="app-site-container">
    <div class="app-router">
      <router-outlet></router-outlet>
    </div>
  </div>
</mat-drawer-container>
